import * as supportApi from './support'
import * as authApi from './auth'
import * as userApi from './user'
import * as songApi from './song'
import * as purchaseApi from './purchase'
import * as serveApi from './serve'
import * as countryApi from './country'
import * as goodApi from './good'
import * as friendApi from './friend'
import * as scoreApi from './score'
import * as eventApi from './event'

export const support = supportApi

export const auth = authApi
export const user = userApi
export const song = songApi
export const purchase = purchaseApi
export const serve = serveApi
export const country = countryApi
export const good = goodApi
export const friend = friendApi
export const score = scoreApi
export const event = eventApi
